'use strict';

module.exports = {    
    'EMAIL_OPTIONS': {
        'optional': 'optional',
        'required': 'required',
        'hide': 'hide'
    },
    'NAME_OPTIONS': {
        'optional': 'optional',
        'required': 'required',
        'hide': 'hide'
    },
}
